<template>
  <section class="quick-quote-info">
    <div class="table">
      <div class="tr th">
        <span>Item</span>
        <span>Information</span>
      </div>
      <div class="tr">
        <span>Age</span>
        <span>{{ getAllOptionName27('age', quoteForm.age_id) }}</span>
      </div>
    </div>
    <div class="table">
      <div class="tr th">
        <span>Item</span>
        <span>Information</span>
      </div>
      <div class="tr">
        <span>Occupation</span>
        <span>{{ getAllOptionName27('occupation', quoteForm.occ_id)  }}</span>
      </div>
    </div>
  </section>
</template>
<script>
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'
export default {
  name: 'QuickQuoteInfo',
  mixins: [MixinOptions, MixinFormat],
  props: {
    quoteForm: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {

    }
  }
}
</script>
<style lang="scss" scoped>
  .quick-quote-info {
    display: flex;
    justify-content: space-between;
    .table {
      width: calc(50% - 10px);
    }
  }
</style>
